export default __webpack_public_path__ + "static/media/Untitled-2.a6279c9f.jpg";